// Plain-language label for a masked customer price's basis (brief
// docs/features/customer-portal-ordering/01_product_brief.md §11:
// customer_price.py's shape is "the only price shape the portal may ever
// render"). Kept here, not inline in each page, so the wording is the same
// wherever a price is shown (catalogue list, item configure, reorder
// pre-fill) — one of naming.md's tripwires ("one concept, one name, in every
// layer").

import type { CustomerPriceBasis } from "../data/customer-api-types";

export function priceBasisLabel(basis: CustomerPriceBasis): string {
  switch (basis) {
    case "agreed_rate":
      return "Your agreed rate";
    case "last_order":
      return "Your last order price";
    case "standard":
      return "Standard price";
    default:
      return "Standard price";
  }
}
